/**
 * MoreLinksMenuItems — section « pages » du menu compte mobile.
 *
 * @remarks
 * La barre du bas (`MobileTabBar`) n'affiche que les liens `top` du registry :
 * les liens `bottom` (boutique, achats, parrainage, admin) sont listés à plat
 * dans le menu compte, juste au-dessus de « Mentions légales » (SAAS-1200).
 * La section s'ouvre sur un séparateur, pour la détacher des items « compte ».
 * Ne rend rien s'il n'y a aucun lien (ni séparateur, sinon il serait doublé).
 */

import { Link } from 'react-router-dom';
import { DropdownMenuItem, DropdownMenuSeparator, Icon } from '@/shared/ui';
import type { Context, ResolvedNavigationLink } from '@/app/registry';

interface Props {
  links: readonly ResolvedNavigationLink[];
  context: Context;
}

export function MoreLinksMenuItems({ links, context }: Props) {
  if (links.length === 0) return null;

  return (
    <>
      <DropdownMenuSeparator />
      {links.map((link) => {
        const LinkIcon = link.icon;
        const isActive = link.activeContexts.includes(context);
        // Lien visible mais désactivé (cf. `NavigationLink.disabled`) : on le
        // garde dans le menu, grisé, sans navigation possible.
        if (link.disabled) {
          return (
            <DropdownMenuItem key={link.id} disabled title={link.disabledTooltip ?? link.label}>
              <Icon icon={LinkIcon} size="md" />
              <span>{link.label}</span>
            </DropdownMenuItem>
          );
        }
        return (
          <DropdownMenuItem key={link.id} asChild>
            <Link
              to={link.to}
              aria-current={isActive ? 'page' : undefined}
              className={isActive ? 'text-primary font-semibold' : undefined}
            >
              <Icon icon={LinkIcon} size="md" />
              <span>{link.label}</span>
            </Link>
          </DropdownMenuItem>
        );
      })}
    </>
  );
}
